import React, { FC, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type ExpansionScrewProps = {
    handleSettings: (propertyName: string, settingValue: string | boolean) => void;
    partExpansionScrew: boolean;
    isRequired?: boolean;
};

const ExpansionScrew: FC<ExpansionScrewProps> = ({
    handleSettings,
    partExpansionScrew,
    isRequired,
}: ExpansionScrewProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [expansionScrew, setExpansionScrew] = React.useState(false);

    useEffect(() => {
        setExpansionScrew(partExpansionScrew);
    }, [partExpansionScrew]);

    const handleChange = (_event: React.SyntheticEvent, checked: boolean) => {
        setExpansionScrew(checked);
        handleSettings('expansionScrew', checked);
    };

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('EXPANSION_SCREW')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                    <FormControlLabel
                        checked={expansionScrew}
                        onChange={handleChange}
                        control={<Checkbox color="secondary" />}
                        label={translate('EXPANSION_SCREW')}
                        labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>
        </PropertyBox>
    );
};

export default ExpansionScrew;
